import { DATE_STRING_FORMAT } from '@revolugo/common/constants'
import { dayjs } from '@revolugo/common/utils'

export const formatQueryDate = (date: Date | string): string =>
  dayjs(date).format(DATE_STRING_FORMAT)
